import { defineStore } from 'pinia'

let nextId = 0

export const useNotificationStore = defineStore('notifications', {
  state: () => ({
    notifications: [],
  }),

  actions: {
    add(message, type = 'info', duration = 5000) {
      const id = ++nextId
      this.notifications.push({ id, message, type })
      if (duration > 0) {
        setTimeout(() => this.remove(id), duration)
      }
    },

    remove(id) {
      this.notifications = this.notifications.filter(n => n.id !== id)
    },

    success(message) { this.add(message, 'success') },
    error(message) { this.add(message, 'error', 8000) },
    warning(message) { this.add(message, 'warning') },
    info(message) { this.add(message, 'info') },
  },
})
